module.exports = __webpack_public_path__ + "static/media/creativesHead.881288de.jpg";